<script>
import ModalOverlay from '@/components/modal/ModalOverlay';
import Button from '@/components/Button';
export default {
  name: 'ModalConfirm',
  components: {
    Button,
    ModalOverlay,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    subTtitle: {
      type: String,
      default: '',
    },
    action: {
      type: String,
      default: 'Ok',
    },
    color: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<template>
  <div class="root">
    <ModalOverlay>
      <div class="modal__dialog">
        <div
          :class="{
            modal__content: true,
            [color]: color,
          }"
        >
          <div class="modal__top">
            <div
              :class="{
                modal__title: true,
              }"
            >
              {{ title }}
            </div>
            <div class="modal__close" @click="$emit('close')">
              <img :src="require('@/assets/svg/close.svg')" />
            </div>
          </div>
          <div class="modal__middle">
            <div class="modal__text">
              {{ subTtitle }}
            </div>
          </div>
          <div class="modal__bottom">
            <Button
              :class="{ 'm-290': true, [color]: color }"
              @click="$emit('confirm')"
            >
              {{ action }}
            </Button>
          </div>
        </div>
      </div>
    </ModalOverlay>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.modal {
  &__dialog {
    padding: 87px 20px 40px;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;

    // &.positive {
    //   display: none;
    // }
  }

  &__content {
    max-width: 570px;
    max-height: 100%;
    border-radius: 36px;
    background-color: #101112;
    border: solid 1px rgba(249, 88, 98, 0.2);
    padding: 0 0 40px;
    display: flex;
    flex-direction: column;
    width: 100%;
    color: #ffffff;

    &.positive {
      border: solid 1px rgba(56, 213, 184, 0.2);
    }

    &.negative {
      border: solid 1px rgba(249, 88, 98, 0.2);
    }
  }

  &__top {
    text-align: center;
    position: relative;
    padding: 40px 0 0;
    flex-shrink: 0;
  }

  &__title {
    font-family: Poppins-Regular;
    font-size: 21px;
    line-height: 29px;
    margin-bottom: 14px;
    padding: 10px 20px;

    &.positive {
      color: #38d5b8;
    }

    &.negative {
      color: #f95862;
    }
  }

  &__text {
    font-family: Poppins-Light;
    font-size: 14px;
    line-height: 1.86;
    max-width: 420px;
    margin: 0 auto;
    width: 100%;
  }

  &__middle {
    flex-grow: 1;
    text-align: center;
  }

  &__bottom {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    margin-top: 50px;
  }

  &__close {
    position: absolute;
    right: 25px;
    top: 25px;
    width: 12px;
    height: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    cursor: pointer;

    img {
      display: flex;
      width: 100%;
      height: 100%;
    }

    &:hover {
      opacity: 0.5;
    }
  }
}

@media (max-width: $mobile) {
  .modal {
    &__dialog {
      padding: 0;
    }

    &__content {
      max-width: none;
      height: 100%;
      border: 0 !important;
      border-radius: 0;
      overflow-y: auto;
      -webkit-overflow-scrolling: tuch;
    }

    &__top {
      padding-top: 100px;
    }

    &__title {
      padding: 0 15px;
    }

    &__middle {
      padding: 0 15px;
    }

    &__bottom {
      padding: 0 15px;
    }
  }
}
</style>
